<template>
  <div>
    <div class="breadcrumb-area pos-relative w-100">
      <h1>Chi tiết điều chuyển</h1>
      <div style="float: right">
        <button
          class="btn btn-light"
          v-if="
            this.dataHistoryDetails.transferStatus === 'PENDING' &&
            dataPermission &&
            dataPermission.includes('CNPS_CSTM_MERCHANT_REFUSE_TRANSFER')
          "
          @click="refuseTrans"
        >
          Từ chối
        </button>
        <button
          class="btn btn-success btn-primary ml-2 mr-2"
          data-toggle="modal"
          v-if="
            this.dataHistoryDetails.transferStatus === 'PENDING' &&
            dataPermission &&
            dataPermission.includes('CNPS_CSTM_MERCHANT_RECEIVE_TRANSFER')
          "
          @click="receiveTrans"
        >
          Xác nhận
        </button>
        <button
          class="btn btn-danger"
          v-if="
            this.dataHistoryDetails.transferStatus === 'PENDING' &&
            dataPermission &&
            dataPermission.includes('CNPS_CSTM_MERCHANT_CANCEL_TRANSFER')
          "
          @click="cancelTrans"
        >
          Hủy bỏ
        </button>
      </div>
    </div>
    <div class="card p-10 pt-15 b-t-1-869fb229">
      <div class="card-body px-20 form-row">
        <div class="col-sm-12 mb-3">
          <div class="form-detail">
            <h1>Thông tin điều chuyển</h1>
            <div class="form-group form-row">
              <label for="" class="col-sm-3 col-form-label"
                >Thời gian tạo <span class="float-right">:</span></label
              >
              <div class="col-sm-9">
                <p class="form-control-plaintext f12">
                  {{ this.dataHistoryDetails.createAt | formatHour1 }},
                  {{ this.dataHistoryDetails.createAt | formatDate1 }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-3 col-form-label"
                >Số lượng merchant<span class="float-right">:</span></label
              >
              <div class="col-sm-9">
                <p class="form-control-plaintext f12">
                  {{ this.dataHistoryDetails.numberOfcustomers }}
                </p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-3 col-form-label"
                >Sales nhận<span class="float-right">:</span></label
              >
              <div class="col-sm-9">
                <p class="form-control-plaintext f12">{{ this.dataHistoryDetails.newSaleName }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-3 col-form-label"
                >Người thực hiện<span class="float-right">:</span></label
              >
              <div class="col-sm-9">
                <p class="form-control-plaintext f12">{{ this.dataHistoryDetails.managerName }}</p>
              </div>
            </div>
            <div class="form-group form-row">
              <label for="" class="col-sm-3 col-form-label"
                >Trạng thái<span class="float-right">:</span></label
              >
              <div class="col-sm-9">
                <p class="form-control-plaintext f12">
                  <span
                    v-if="this.dataHistoryDetails.transferStatus === 'PENDING'"
                    class="badge badge-warning"
                    >Chờ xác nhận</span
                  >
                  <span
                    v-else-if="this.dataHistoryDetails.transferStatus === 'RECEIVED'"
                    class="badge badge-success"
                    >Đã nhận</span
                  >
                  <span
                    v-else-if="this.dataHistoryDetails.transferStatus === 'REFUSE'"
                    class="badge badge-danger"
                    >Từ chối</span
                  >
                  <span
                    v-else-if="this.dataHistoryDetails.transferStatus === 'CANCEL'"
                    class="badge badge-secondary"
                    >Đã hủy</span
                  >
                </p>
              </div>
            </div>
          </div>
          <div class="form-detail">
            <h1>Danh sách Merchant</h1>
            <div class="tab-content">
              <div class="table-responsive">
                <table class="table table-hover table-bordered" id="tableScroll">
                  <thead class="thead-light">
                    <tr>
                      <th width="50">STT</th>
                      <th scope="col">Tên merchant</th>
                      <th scope="col">Số điện thoại</th>
                      <th scope="col">Email</th>
                      <th scope="col">Địa chỉ</th>
                      <th scope="col">Vùng kinh doanh</th>
                      <th scope="col">Tỉnh/Thành phố</th>
                      <th scope="col">Sales cũ/Agent</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      class="table-row"
                      v-for="(item, index) in dataHistoryDetails.lstCustomers"
                      :key="index"
                    >
                      <td>
                        {{ search.pagination.size * (search.pagination.page - 1) + index + 1 }}
                      </td>
                      <td>{{ item.customerName }}</td>
                      <td>{{ item.mobile }}</td>
                      <td>{{ item.email }}</td>
                      <td>{{ item.address }}</td>
                      <td>{{ item.regionName }}<br />{{ item.city }}</td>
                      <td>{{ item.city }}</td>
                      <td>{{ item.oldSaleName }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Modal thông báo -->
    <b-modal id="modal-scoped" v-model="notiModal">
      <template #modal-header="{ close }">
        <h5>Thông báo</h5>
        <b-button size="sm" variant="light" @click="close()"> x </b-button>
      </template>
      <div class="text-center">
        <img :src="iconNoti" :alt="iconNoti" />
        <h2 class="f18 py-3">{{ msgNoti }}</h2>
      </div>
      <template #modal-footer="{ cancel }">
        <b-button size="sm" variant="light" @click="cancel()"> Đóng </b-button>
      </template>
    </b-modal>
  </div>
</template>
<script>
  import { MerchantService } from '@/services/merchant.service'
  import { mapGetters } from 'vuex'
  export default {
    name: 'detailConfirmTrans',
    data() {
      return {
        transferId: this.$route.params.transferId,
        dataUser: JSON.parse(localStorage.getItem('userData')),
        dataHistoryDetails: [],
        search: {
          pagination: {
            page: 1,
            size: 50,
          },
        },
        notiModal: false,
        msgNoti: '',
        iconNoti: '',
      }
    },
    mounted() {
      this.fetchData()
    },
    computed: {
      ...mapGetters({
        dataPermission: 'role/dataPermission',
      }),
    },
    methods: {
      // hủy điều chuyển
      async cancelTrans() {
        if (this.dataHistoryDetails.managerEmail === this.dataUser.username) {
          try {
            const body = {
              transferId: this.transferId,
            }
            const data = await MerchantService.cancelTransfer(body)
            if (data.success) {
              this.$router.push({ path: '/history-trans' })
            }
          } catch (error) {
            console.log(error)
          } finally {
            this.loading = false
          }
        } else {
          this.notiModal = true
          this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          this.msgNoti = 'Bạn không có quyền thực hiện thao tác này'
        }
      },
      // nhận điều chuyển
      async receiveTrans() {
        if (this.dataHistoryDetails.newSaleEmail === this.dataUser.username) {
          try {
            const body = {
              transferId: this.transferId,
            }
            const data = await MerchantService.receiveTransfer(body)
            if (data.success) {
              this.$router.push({ path: '/confirm-trans' })
            }
          } catch (error) {
            console.log(error)
          } finally {
            this.loading = false
          }
        } else {
          this.notiModal = true
          this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          this.msgNoti = 'Bạn không có quyền thực hiện thao tác này'
        }
      },
      // từ chối điều chuyển
      async refuseTrans() {
        if (this.dataHistoryDetails.newSaleEmail === this.dataUser.username) {
          try {
            const body = {
              transferId: this.transferId,
            }
            const data = await MerchantService.refuseTransfer(body)
            if (data.success) {
              this.$router.push({ path: '/confirm-trans' })
            }
          } catch (error) {
            console.log(error)
          } finally {
            this.loading = false
          }
        } else {
          this.notiModal = true
          this.iconNoti = require('@/assets/img/noti-unsuccess2.svg')
          this.msgNoti = 'Bạn không có quyền thực hiện thao tác này'
        }
      },
      // dữ liệu bảng
      async fetchData() {
        this.loading = true
        this.search.transferId = this.transferId
        try {
          const data = await MerchantService.historyTransDetail(this.search)
          if (data.success) {
            this.dataHistoryDetails = data.data
          }
        } catch (error) {
          console.log(error)
        } finally {
          this.loading = false
        }
      },
    },
  }
</script>
